import './App.css';
import { useState } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
// LXD Ethiopia Components
import LXDNavbar from './components/LXDNavbar';
import LXDHome from './components/LXDHome';
import LXDCourses from './components/LXDCourses';
import LXDAbout from './components/LXDAbout';
import LXDContact from './components/LXDContact';
import LXDFooter from './components/LXDFooter';
import LXDCourseDetail from './components/LXDCourseDetail';
import LXDLesson from './components/LXDLesson';
import LXDDashboard from './components/LXDDashboard';
import LXDOnboarding from './components/LXDOnboarding';
// Legacy Components (kept for compatibility)
import NavBar from './components/NavBar';
import Body from './components/Body';
import SimpleSlider from './components/HeroCarousel';
import HeroSection from './components/HeroSection';
import OurBestSellers from './components/OurBestSellers';
import Ingridients from './components/Ingridients';
import JournalSection from './components/JournalSection';
import BsText from './components/BsText';
import SinglePage from "./components/SinglePage";
import JournalPage from "./components/JournalPage";
import SPFooter from './components/SPFooter';
import ContactUs from './components/Contatusnew';
import AboutUs from './components/Aboutus';
import BotChat from './components/BotChat';
import ProductList from './components/ProductList';
import Loginpage from './components/Loginpage';
import ChangePasswordComponent from './components/ChangePasswordComponent';
import TestimonialSection from './components/TestimonialSection';
import Changepass from './components/Changepass';
import Newtest from './components/Newtest';
import PopupComponent from './components/PopupComponent';
import NavAvatar from './components/NavAvatar';
import HomePage1 from './components/HomePage1';
import WelcomePage from './components/WelcomePage';
import ProductListt from './components/ProductListt';
import Services from './components/Services';
import Electromechanical from './components/Electromechanical';
import ScadaSolutions from './components/ScadaSolutions';
import Privacy from './components/Privacy';
import Testimonials from './components/Testimonials';
import TechnologicalSolutions from './components/TechnologicalSolutions';
import Home from './components/Home';
import Navbarr from './components/Navbarr';
import ToastComponent from './components/ToastComponent';
import RegisterForm from './components/RegisterForm';
import LoadingLogo from './components/LoadingLogo';
import Someofourcustomers from'./components/Someofourcustomers';
import CardComponent from './components/CardComponent';
import FormComponent from './components/FormComponent';
import SignInSide from './components/SignInSide';
import SignUp from './components/SignUp';
import Newsn from './components/Newsn';
import Checkout from './components/Checkout';
import FormDownload from './components/FormDownload';
import Navbard from './components/Navbard';
import Drogalogin from './components/Drogalogin';
import AboutUsPage from './components/AboutUsPage';
import Newproducttoaboutus from './components/Newproducttoaboutus';
import EmployeeSendMessage from  './components/EmployeeSendMessage';
import ManagerMessageList from './components/ManagerMessageList';
import Notification from './components/Notification';
import Botchatdroga from './components/Botchatdroga';
import Chatbot from './components/Chatbot';
import OurMission from './components/OurMission';
import Atest from './components/Atest'



function App() {

  return (
    <div className="App">
      <BrowserRouter>

        <Routes >
          {/* LXD Ethiopia Routes */}
          <Route path='/' exact element={<> <LXDNavbar /> <LXDHome /> <LXDFooter /> </>} />
          <Route path='/onboarding' element={<> <LXDNavbar /> <LXDOnboarding /> </>} />
          <Route path='/courses' element={<> <LXDNavbar /> <LXDCourses /> <LXDFooter /> </>} />
          <Route path='/courses/:id' element={<> <LXDNavbar /> <LXDCourseDetail /> <LXDFooter /> </>} />
          <Route path='/courses/:id/lessons/:lessonId' element={<> <LXDNavbar /> <LXDLesson /> </>} />
          <Route path='/dashboard' element={<> <LXDNavbar /> <LXDDashboard /> <LXDFooter /> </>} />
          <Route path='/about' element={<> <LXDNavbar /> <LXDAbout /> <LXDFooter /> </>} />
          <Route path='/contact' element={<> <LXDNavbar /> <LXDContact /> <LXDFooter /> </>} />
          
          {/* Legacy Routes (kept for compatibility) */}
          <Route path='/legacy' exact element={<>   <Navbarr /> <Home /> <Ingridients />  <ProductList withSeo={false} /> <Services withSeo={false} /> <TestimonialSection /> <ContactUs withSeo={false} /> <Someofourcustomers /> <SPFooter /> <BotChat /> </>} />

          <Route path='/journal/april' element={<> <Navbarr /> <JournalPage /> </>} />
          <Route path='/contactus' element={<Navigate to="/contact" replace />} />
          <Route path='/Aboutus' element={<Navigate to="/about" replace />} />
          <Route path='/botchat' element={<> <Navbarr />  <BotChat /> </>} />
          <Route path='/productlist' element={<> <Navbarr />  <ProductList /> </>} />
          <Route path='/login' element={<> <Loginpage /> </>} />
          <Route path='/changepassword' element={<> <ChangePasswordComponent /> </>} />
          <Route path='/TestimonialSection' element={<> <Navbarr />  <TestimonialSection /> </>} />
          <Route path='/Changepass' element={<> <Changepass />  <test /> </>} />
          <Route path='/NavAvatar' element={<> <NavAvatar /> </>} />
          <Route path='/WelcomePage' element={<> <WelcomePage /> </>} />
          <Route path='/ProductListt' element={<> <Navbarr /> <ProductListt /> </>} />
          <Route path='/services' element={<> <Navbarr /> <Services />   </>} />
          <Route path='/Services' element={<Navigate to="/services" replace />} />
          <Route path='/electromechanical-systems-dubai' element={<> <Navbarr /> <Electromechanical /> </>} />
          <Route path='/scada-solutions-dubai' element={<> <Navbarr /> <ScadaSolutions /> </>} />
          <Route path='/privacy' element={<> <Navbarr /> <Privacy /> </>} />
          <Route path='/product/:id' element={<> <Navbarr /> <SinglePage /> </>} />
          <Route path='/Testimonials' element={<> <Testimonials /> </>} />
          <Route path='/TechnologicalSolutions' element={<> <TechnologicalSolutions /> </>} />
          <Route path='/Home' element={<> <Home /> </>} />
          <Route path='/ToastComponent' element={<> <ToastComponent /> </>} />
          <Route path='/RegisterForm' element={<> <RegisterForm /> </>} />
          <Route path='/LoadingLogo' element={<> <LoadingLogo /> </>} />
          <Route path='/CardComponent' element={<> <CardComponent /> </>} />
          <Route path='/FormComponent' element={<> <FormComponent /> </>} />
          <Route path='/Checkout' element={<> <Checkout /> </>} />
          {/* <Route path='/FormDownload' element={<> <Navbard /> <FormDownload /> </>} /> */}
          <Route path='/Navbard' element={<> <Notification /><Navbard /> </>} />
          {/* // <Route path='/Drogalogin' element={<> <Drogalogin /> </>} /> */}
          <Route path='/AboutUsPage' element={<> <AboutUsPage /> </>} />
          <Route path='/Newproducttoaboutus' element={<> <Newproducttoaboutus /> </>} />

          <Route path='/Chatbot' element={<> <Chatbot /> </>} />
          <Route path='/OurMission' element={<> <OurMission /> </>} />
          <Route path='/Atest' element={<> <Atest /> </>} />
        </Routes>

      </BrowserRouter>




    </div>
  );
}

export default App;




